import { useEffect, useState } from 'react';
import { staffApi } from '@/lib/api';
import { Button } from '@/components/ui/button';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import ActivateSubscriptionDialog from '@/components/shared/ActivateSubscriptionDialog';

export default function PendingPayments() {
  const [subscriptions, setSubscriptions] = useState([]);
  const [activatingId, setActivatingId] = useState(null);

  const load = () => staffApi.get('/subscriptions', { params: { status: 'PENDING' } }).then(({ data }) => setSubscriptions(data.subscriptions));

  useEffect(() => {
    load();
  }, []);

  return (
    <div className="space-y-4">
      <h1 className="font-heading text-2xl font-700 text-charcoal">Pending Payments</h1>

      <div className="bg-white rounded-xl border border-border/40 overflow-x-auto">
        <Table>
          <TableHeader>
            <TableRow className="bg-bone/60">
              <TableHead>Customer</TableHead>
              <TableHead>Phone</TableHead>
              <TableHead>Plan</TableHead>
              <TableHead>Amount Due</TableHead>
              <TableHead>Payment Choice</TableHead>
              <TableHead>Registered</TableHead>
              <TableHead></TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {subscriptions.map((s) => (
              <TableRow key={s.id} data-testid="pending-payment-row">
                <TableCell className="font-medium">{s.customer.name}</TableCell>
                <TableCell>{s.customer.phone}</TableCell>
                <TableCell>{s.planNameSnapshot || s.plan?.name}</TableCell>
                <TableCell>${Number(s.finalAmount).toFixed(2)}</TableCell>
                <TableCell>{s.paymentMethodChoice || '—'}</TableCell>
                <TableCell>{new Date(s.createdAt).toLocaleDateString('en-CA')}</TableCell>
                <TableCell>
                  <Button
                    size="sm"
                    data-testid={`activate-btn-${s.id}`}
                    onClick={() => setActivatingId(s.id)}
                    className="bg-saffron hover:bg-saffron-hover"
                  >
                    Confirm Payment & Activate
                  </Button>
                </TableCell>
              </TableRow>
            ))}
            {subscriptions.length === 0 && (
              <TableRow>
                <TableCell colSpan={7} className="text-center text-muted-ink py-8">No pending payments right now.</TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </div>

      {activatingId && (
        <ActivateSubscriptionDialog
          api={staffApi}
          subscriptionId={activatingId}
          onClose={() => setActivatingId(null)}
          onDone={() => {
            setActivatingId(null);
            load();
          }}
        />
      )}
    </div>
  );
}
